import { buildScopedI18n } from '../../../../utils/buildScopedI18n';
import delegationsEsCL from './locales/es-CL.json';
import delegationsEnUS from './locales/en-US.json';
import delegationsPtBR from './locales/pt-BR.json';

export const delegationsI18n = buildScopedI18n({
  esCL: delegationsEsCL,
  enUS: delegationsEnUS,
  ptBR: delegationsPtBR,
});
